// src/lib/mauticTracker.ts

/**
 * 安全过滤函数（防止XSS/注入）
 */
const sanitizeInput = (value: unknown): string => {
  if (value == null || value === '') return '';
  return String(value).replace(/[<>"'\x00-\x1F\x7F]/g, '');
};

/**
 * 发送数据到 Mautic
 * @param params 包含事件名称、描述、标签及动态字段
 * @param callbacks 可选的回调函数（onload/onerror）
 */
export const trackMautic = (
  params: {
    eventName?: string;    // 自定义 page_url（覆盖默认的当前页面链接）
    eventDescription?: string; // 自定义 page_title（覆盖默认的当前页面标题）
    tags?: string;
    [key: string]: unknown;
  },
  callbacks?: {
    onload?: () => void;
    onerror?: () => void;
  }
) => {
  // 检查全局 mt 函数是否可用
  if (typeof window === 'undefined') {
    return;
  }

  // 动态字段过滤与映射（跳过 eventName、eventDescription 和 tags）
  const fields: Record<string, string> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== '' && !['eventName', 'eventDescription', 'tags'].includes(key)) {
      fields[key] = sanitizeInput(value);
    }
  });

  // 设置 page_url 和 page_title 的默认值或自定义值
  const pageUrl = params.eventName ? sanitizeInput(params.eventName) : window.location.href;
  const pageTitle = params.eventDescription ? sanitizeInput(params.eventDescription) : document.title;

  // 构建 Mautic 事件数据
  const eventData: Record<string, string> = {
    page_url: pageUrl,      // 优先用 eventName，否则用当前页面链接
    page_title: pageTitle,  // 优先用 eventDescription，否则用当前页面标题
    ...(params.tags && { tags: sanitizeInput(params.tags) }),
    ...fields,
  };

  // ==== 修改点：严格编码 URL 参数（空格 -> %20）====
  const queryString = Object.entries(eventData)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  // 获取 Mautic 基础 URL（从环境变量或默认配置）
  const mauticBaseUrl = process.env.GATSBY_MAUTIC_URL || 'https://m.paganidesignwatch.com';

  // 创建 Tracking Pixel
  const pixel = document.createElement('img');
  pixel.src = `${mauticBaseUrl}/mtracking.gif?${queryString}`; // 使用手动编码的字符串
  pixel.style.display = 'none';
  pixel.alt = 'Mautic Tracking Pixel';

  // 添加到页面
  document.body.appendChild(pixel);
};